interface EventIdentityProps {
  selfNames: string[];
  viewingName: string;
  isOverlapTimes: boolean;
  isScheduleEventMode: boolean;
  isOwner: boolean;
}

const EventIdentity = ({
  selfNames,
  viewingName,
  isOverlapTimes,
  isScheduleEventMode,
  isOwner,
}: EventIdentityProps) => {
  return (
    <div className="text-start text-sm pb-2 text-gray-600">
      {selfNames.length > 0 ? (
        <span>
          {selfNames.length === 1 ? (
            <>
              You are <b>{selfNames[0]}</b>.{' '}
            </>
          ) : (
            <>
              You own: <b>{selfNames.join(', ')}</b>.{' '}
            </>
          )}
          {isScheduleEventMode ? (
            <>Viewing the schedule event.</>
          ) : isOverlapTimes ? (
            <>Viewing overlapping times for all participants.</>
          ) : (
            <>
              Viewing <b>{viewingName}</b>.{' '}
              {isOwner
                ? 'As the event owner, you can change the event details and date range.'
                : 'As a participant, you can add or update your availability.'}
            </>
          )}
        </span>
      ) : (
        <span>
          You haven't joined this meeting planner. Enter your name and press{' '}
          <b>Join</b> to add your availability.
        </span>
      )}
    </div>
  );
};

export default EventIdentity;
